import { Component, Inject } from '@angular/core';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'confirm-dialog',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		MatDialogModule,
		MatButtonModule,
		MatFormFieldModule,
		MatInputModule
	],
	template: `
   <h2 class="mat-dialog-title" mat-dialog-title>{{ data.title }}</h2>
	<mat-dialog-content>
		<p>{{ data.text }}</p>
		<mat-form-field *ngIf="data.prompt" appearance="fill" style="width:100%;">
			<textarea matInput [(ngModel)]="inputValue"></textarea>
		</mat-form-field>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button mat-button class="confirmDialogBtn" *ngIf="data.cancelText" (click)="onCancelClick()">{{ data.cancelText || 'Cancel' }}</button>
		<button mat-button class="confirmDialogBtn" color="primary" (click)="onConfirmClick()">{{ data.okText || 'OK' }}</button>
	</mat-dialog-actions>

  `
})
export class ConfirmDialogComponent {
  inputValue = '';

  constructor(
    @Inject(MatDialogRef<ConfirmDialogComponent>) public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string;
      text?: string;
      prompt?: boolean; 
      okText?: string;
      cancelText?: string;
    }
  ) {}

  onConfirmClick(): void {
    this.dialogRef.close(this.data.prompt ? this.inputValue : true);
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}
